import * as TE from 'fp-ts/lib/TaskEither'
import { pipe } from 'fp-ts/lib/function'

import { fetchApi } from './lib/fetchApi'
import type { ErrorResponse } from './lib/types'

export type GenerateDynamicPackageHashResponse = {
  attributeHash: string
}

function isGenerateDynamicPackageHashResponse(
  res: unknown
): res is GenerateDynamicPackageHashResponse {
  return !!res && typeof res === 'object' && Object.hasOwn(res, 'attributeHash')
}

type GenerateDynamicPackageHashRequest = {
  readonly auxiliarySiren?: number
  readonly bellBox?: number
  readonly carbonMonoxideDetector?: number
  readonly entrySensor?: number
  readonly freezeSensor?: number
  readonly glassbreakSensor?: number
  readonly keyFob?: number
  readonly keypad?: number
  readonly motionSensor?: number
  readonly outdoorCamera?: number
  readonly panicButton?: number
  readonly simplicam?: number
  readonly smokeDetector?: number
  readonly videoDoorbellPro?: number
  readonly waterSensor?: number
  readonly indoorCam?: number
}

/**
 * Generates a dynamic package hash via the products API
 * @param request dynamic package components to be hashed
 * @returns
 */
export function generateDynamicPackageHash(
  request: GenerateDynamicPackageHashRequest
): TE.TaskEither<Error | ErrorResponse, GenerateDynamicPackageHashResponse> {
  return pipe(
    fetchApi({
      endpoint: `/products/v1/dynamic-packages/attribute-hash`,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    }),
    TE.chain(res =>
      isGenerateDynamicPackageHashResponse(res)
        ? TE.right(res)
        : TE.left(Error('Unable to generate dynamic package hash'))
    )
  )
}
